import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, type Observable } from 'rxjs';

import type { MaloupeCategoryDto } from '@malou-io/package-dto';
import type { ApiResultV2 } from '@malou-io/package-utils';

import { environment } from ':environments/environment';
import { Category } from ':shared/models';

@Injectable({
    providedIn: 'root',
})
export class CategoryHttpService {
    readonly API_BASE_URL = `${environment.APP_MALOU_API_URL}/api/v1/categories`;

    private readonly _http = inject(HttpClient);

    getAllCategories$(): Observable<ApiResultV2<Category[]>> {
        return this._http.get<ApiResultV2<MaloupeCategoryDto[]>>(`${this.API_BASE_URL}/google`).pipe(
            map((res) => ({
                ...res,
                data: res.data.map((category) => new Category(category)),
            }))
        );
    }

    getGoogleCategory$(placeId: string): Observable<ApiResultV2<string>> {
        return this._http.get<ApiResultV2<string>>(`${this.API_BASE_URL}/google/${placeId}`);
    }
}
